/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DiscreditedProviderCardInfoAliases {
  DESKTOP_BUTTON_DS_ADDRESS_GMAPS = 'desktop-button-dsAddressGmaps',
  DESKTOP_BUTTON_PRODUCTS = 'desktop-button-products',
  HPMS_DYNAMIC_CONTENT_FIELD_BUTTON = 'hpms-dynamic-content-field-button',
  HPMS_DYNAMIC_CONTENT_FIELD_DS_ADDRESS = 'hpms-dynamic-content-field-dsAddress',
  HPMS_DYNAMIC_CONTENT_FIELD_DS_PHONE = 'hpms-dynamic-content-field-dsPhone',
  HPMS_DYNAMIC_CONTENT_FIELD_DS_WEB_SITE = 'hpms-dynamic-content-field-dsWebSite',
  HPMS_DYNAMIC_CONTENT_FIELD_ICONS_D = 'hpms-dynamic-content-field-icons-D',
  MOBILE_BUTTON_DS_ADDRESS_GMAPS = 'mobile-button-dsAddressGmaps',
  MOBILE_BUTTON_PRODUCTS = 'mobile-button-products',
  PANEL_1 = 'panel-1',
  PANEL_COMPACT_NAME = 'panel-compactName',
  PANEL_CONTENT = 'panel-content',
  PANEL_DESKTOP_LINKS = 'panel-desktopLinks',
  PANEL_DS_AREA = 'panel-dsArea',
  PANEL_DS_EMAIL = 'panel-dsEmail',
  PANEL_DS_REASON = 'panel-dsReason',
  PANEL_DS_SPECIALITY = 'panel-dsSpeciality',
  PANEL_DS_TYPE_PROVIDER = 'panel-dsTypeProvider',
  PANEL_MOBILE_LINKS = 'panel-mobileLinks',
  PANEL_ROOT = 'panel-root',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_50 = 'text-50',
  TEXT_COMPACT_NAME = 'text-compactName',
  TEXT_DS_AREA = 'text-dsArea',
  TEXT_DS_EMAIL = 'text-dsEmail',
  TEXT_DS_REASON = 'text-dsReason',
  TEXT_DS_SPECIALITY = 'text-dsSpeciality',
  TEXT_DS_TYPE_PROVIDER = 'text-dsTypeProvider',
  TEXT_EMAIL = 'text-email',
  TEXT_REASON = 'text-Reason',
}
export { DiscreditedProviderCardInfoAliases };
